module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Lamp#2-9352d06aba9ae5e931e03e9c4b7fbe5e57aa7be159f1c885d5c70f5f55b985aa.svg";